import React, { useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import GoBack from "../subsidiary/GoBack/GoBack"
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import styles from './Login.module.css'
import Button from '@mui/material/Button'
import { useDispatch } from 'react-redux'
import { sendCall, sendSms, setUserNumber } from './loginSlice'
import InputMask from "react-input-mask";

const Login = () => {
  const navigation = useNavigate()
  const dispatch = useDispatch()
  const [mascedInput, setMascedInput] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const path = useMemo(() => {
    const parts = window.location.pathname.split('/').filter(Boolean)
    return parts[parts.length - 1] || ''
  }, [])

  const isIncoming = path.toLowerCase().includes('incoming')
  const isOutgoing = path.toLowerCase().includes('outgoing')

  const handleNumberChange = (e) => {
    setPhoneNumber(e.target.value)
    setMascedInput(e.target.value.trim().replace(/[^0-9]/g, ''))
  }

  const showError = (params) => {
    const message =
      (typeof params?.payload === 'string' && params.payload) ||
      params?.payload?.message ||
      params?.error?.message ||
      'Не удалось отправить запрос. Проверьте номер и попробуйте снова.'
    window.showAlert?.({
      title: message,
      type: 'error',
    })
  }

  const submitHandler = (e) => {
    e?.preventDefault?.()
    if (submitting) return

    if (!mascedInput || mascedInput.length < 11) {
      window.showAlert?.({
        title: 'Введите корректный номер телефона',
        type: 'warning',
      })
      return
    }

    setSubmitting(true)

    if (isIncoming) {
      dispatch(sendSms({ phoneNumber: mascedInput })).then((params) => {
        setSubmitting(false)
        if (!params.error) {
          dispatch(setUserNumber(mascedInput))
          navigation('/login/sms')
        } else {
          showError(params)
        }
      })
      return
    }

    if (isOutgoing) {
      dispatch(sendCall({ phoneNumber: mascedInput })).then((params) => {
        setSubmitting(false)
        if (!params.error) {
          dispatch(setUserNumber(mascedInput))
          navigation('/outgoingCall')
        } else {
          showError(params)
        }
      })
      return
    }

    setSubmitting(false)
    window.showAlert?.({
      title: 'Выберите способ авторизации заново',
      type: 'warning',
    })
  }

  return (
    <section className={'main ' + styles.loginPage}>
      <GoBack text='Назад' />
      <div className="content-wrapper">
        <form
          name="form1"
          className={styles.formWrapper}
          onSubmit={submitHandler}
        >
          <h1 className={"page-title " + styles.title}>
            Войти <br /> в личный кабинет
          </h1>
          <span className={styles.input_title}>
            {isIncoming
              ? 'Укажите ваш номер телефона для входящего звонка'
              : 'Укажите ваш номер телефона'}
          </span>
          {isOutgoing && (
            <ol className={styles.loginSteps}>
              <li>Введите номер, с которого будете звонить</li>
              <li>
                Нажмите <strong>«Получить номер»</strong>
              </li>
              <li>Позвоните на показанный номер — вход выполнится сам</li>
            </ol>
          )}
          <FormControl className={styles.input}>
            <InputMask
              onChange={handleNumberChange}
              mask="+7 (***) *** ** **"
              value={phoneNumber}
              disabled={submitting}
              maskChar=" "
            >
              {() => <TextField placeholder='Номер телефона' />}
            </InputMask>
          </FormControl>
          {isOutgoing && (
            <p className={styles.inputHint}>
              После нажатия кнопки появится номер, на который нужно позвонить
            </p>
          )}
          <Button
            type="submit"
            disabled={submitting}
            className={styles.sendBtn}
            variant="contained"
          >
            {submitting
              ? isOutgoing
                ? 'Получаем номер…'
                : 'Отправка…'
              : isOutgoing
                ? 'Получить номер'
                : 'Отправить'}
          </Button>
        </form>
      </div>
    </section>
  )
}
export default Login
